import { getStrings } from "../../../../Common/Localization/commonStrings";


const localizedStrings = {
  PbTurnOnPopup: {
    strings: {
      en: {
          pbBulkNote:"Note: Bulk updates may not be reflected immediately.",
          TurnOnPopupTitle:"Turn On Paperless Billing",
          TurnOnButtonValue:"Turn On Paperless Billing",
          Account:"Set notifications for:",
          Email:"Send email notifications to:",
          CancelButtonValue:"Cancel",
          Resubmit:"Click here to resubmit",
          PbTNC: "I have read and agree to the Terms and Conditions.",
          errorMsg:"Something went wrong on our end.",
          displayText:"(Your primary email)",
          addAccounts:"Add More Accounts",
          inEligibleReason:"Because you are enrolled in another billing option, you are ineligible for Paperless Billing. For assistance, please call 1-800-655-4555.",
          tncError:"You must agree to the Terms and Conditions.",
        ErrMsg: "Unable to process the request, try again later"
              },
            
            
      es: {
      }
    },
    common: ['globalError']
  },
  PbBulkEnrollPopup: {
    strings: {
      en: {
        
          TurnOnPopupTitle:"Turn On Paperless Billing",
          BackMsg:"Back",
          AddAccounts:"Please select accounts",
          WarnMsg:"Selections will not be saved across pages. To save, please submit account  selections on each page before proceeding to subsequent pages.",
          notEnrolled: 'Not enrolled',
          ineligible: 'Ineligible',
          alreadyEnrolled: 'Already enrolled',
          filterBy:'Filter By:',
          notEnrolledEligiable: 'NOT ENROLLED AND ELIGIBLE',
          enrolled: 'ENROLLED',
          notEnrolledNotEligiable: 'NOT ENROLLED AND INELIGIBLE',
          programName: 'PAPERLESS BILLING'
              },
            
            
      es: {
      }
    },
    common: ['globalError']
  },
  PbConfPopup: {
    strings: {
      en: {
        
          TurnOnPopupTitle:"Turn On Paperless Billing",
          TurnOnButtonValue:"Turn On Paperless Billing",
          Account:"Set notifications for:",
          Email:"Email notifications will be sent to: ",
          Message: "Electronic Billing and Notifications successfully processed.",
          BillAvailable:"Your bill will be available on: ",
          GenericBillMsg:"You will begin receiving Paperless Billing notifications on your next statement date.",
          Done:"Done",
          BulkEnrollMsg:"Paperless Billing was successfully turned on for",
          ActMsg:" accounts",
          BulkEnrollErrMsg1:"Paperless Billing could not be turned on for the following",
          BulkEnrollErrMsg2:"accounts. Please resubmit your request.",
          BulkEnrollTitle:"Paperless Billing was successfully turned on for",
          Of:"of",
          Accounts:"Accounts."
          //BulkEnrollMsg:"Paperless Billing was successfully turned on for 10 accounts.",
          
              },
            
            
      es: {
      }
    },
    common: ['globalError']
  },
  ServiceAccountDetails: {
    strings: {
      en: {
         Account:"- Account ending ",
          },
            
            
      es: {
      }
    },
    common: ['globalError']
  },
  PbViewEditPopup: {
    strings: {
      en: {
          ViewEditPopupTitle:"View / Edit Paperless Billing",
          DoneButtonValue:"Done",
          Account:"Set notifications for:",
          Email:"Send email notifications to: ",
          CancelButtonValue:"Cancel",
          RemoveButtonValue:"Remove",
          AddButtonValue:"Add",
          EditButtonValue:"Edit",
          SaveButtonValue:"Save",
          SaveWarnMsg:"Updating this email address will automatically update all your existing email alert preferences for this email address.",
          UpdateSuccessMsg: " All Updates have been successfully processed.",
          UpdateFailureMsg: " We are unable to complete your request, please try again.",
          CloseButtonValue: "OK",
          PbAlertAddEmail: "Add email",
          ShowMore: "Show More",
          ShowLess: "Show Less",
          emailExistsError: 'Email Address already exists'
          },
            
            
      es: {
      }
    },
    common: ['globalError']
  },
  PbTurnOffPopup: {
    strings: {
      en: {
          TurnOffPopupTitle:"Turn Off Paperless Billing",
          TurnOffButtonValue:"Yes, Turn Off Paperless Billing",
          Content:"Are you sure you want to turn off Paperless Billing for this account?",
          CancelButtonValue:"Cancel",
          CloseButtonValue: "Close",
          YesPrefTurnOff: "There are additional email addresses on file for this account. Would you like to unenroll all email addresses assigned to the account and begin receiving your bills through the US Mail?",
          NoPrefTurnOff: "Would you like to opt out of Paperless Billing and start Receiving your bills in the US Mail?",
          SingleEmailRemove: "You have successfully removed the email address from receiving future paperless billing invoices. The account will remain on Paperless Billing.",
          OptOutMsg: "You have successfully opted out of Paperless Billing.  You will now receive your paper bill through the US Mail.",
          CancelMsg: "No changes have been made to your Billing & Payment preferences at this time.",
          UpdateSuccessMsg: " All Updates have been successfully processed.",
          UpdateFailureMsg: " We are unable to complete your request, please try again."
          
          },
            
            
      es: {
      }
    },
    common: ['globalError']
  },

  PbTNC: {
    strings: {
      en: {
        PbTNC: 'I have read and agree to the Terms and Conditions.',
        //mustAgreeTNC: 'You must agree to the Terms and conditions.',
        showMore: 'Show More',
        showLess: 'Show Less',
        PbTooltipInfo:"Please enroll accounts for each page before advancing to subsequent pages. Upon enrolling up to 10 accounts per page, you will be given the option to enroll accounts on subsequent pages."
      }
    },
    common: []
  }
};

export const getLocalizedStrings = (componentName) => {
  app.logger.getLogger().debug("Comp Name" + componentName);
  var strings = getStrings(localizedStrings[componentName].strings,
    localizedStrings[componentName].common,true);
    return strings;
 // return new LocalizedStrings(strings);
};
